var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.003,
    height: 12.999,
    viewBox: "0 0 13.003 12.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-icon",
    d: "M9.02,9.722a5.506,5.506,0,1,1,.706-.707L13,12.292,12.3,13ZM1,5.5A4.5,4.5,0,1,0,5.5,1,4.5,4.5,0,0,0,1,5.5Z",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.c142b9ad9c38ac41d9a06652873dec5b.svg";
export { ForwardRef as ReactComponent };